import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ColorPicker } from 'primereact/colorpicker';
import { postData } from '@/services/api.service';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { fetchCroppedImage } from '@/utils/constants';
import ImageCropper from '@/components/imageCropper/imageCropper';
import { iPhone11, iPhone13 } from '@/utils/imagepath';
import { ImageType } from '@/services/openai.service';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
const MobileAppEditModal = ({ themeData, getThemeData }: any) => {
  const [editData, setEditData] = useState<any>(themeData);
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);


  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [bannerImages, setBannerImages] = useState<string[]>([]);
  const images: Array<string> = [iPhone11, iPhone13];

  // Auto-generate prompt based on mobile app section context
  const generateAutoPrompt = (): string => {
    // Get context from the current mobile app section data (theme_2)
    const title = editData?.theme_2?.home?.section_9?.title || '';
    const paragraph = editData?.theme_2?.home?.section_9?.paragraph || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional image for mobile app section';
    
    if (title || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        // Extract keywords from paragraph
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add mobile app-specific styling
    contextPrompt += ', clean modern aesthetic, professional photography, smartphone mockup, mobile app interface, suitable for mobile app section, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI image save
  const handleAIImageSave = (imageUrl: string) => {
    // Set the banner image
    handleImageChange(imageUrl);
    
    // Add to banner images array for slider
    setBannerImages(prevImages => [...prevImages, imageUrl]);
  };

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const handleChange = (e: any) => {
    const { value, name } = e.target;
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_9: {
            ...prevJsonData.theme_2.home.section_9,
            [name]: value,
          },
        },
      },
    }));
  };

  const handleImageChange = (image: string) => {
    //Update the banner value in the JSON data
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_2: {
        ...prevJsonData.theme_2,
        home: {
          ...prevJsonData.theme_2.home,
          section_9: {
            ...prevJsonData.theme_2.home.section_9,
            banner: image,
          },
        },
      },
    }));
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink);
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load banner images from Redux
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template2';
      const currentTemplate = templateImages[templateKey];
      const imageArray = currentTemplate?.image || [];
      
      if (Array.isArray(imageArray) && imageArray.length > 0) {
        const imageUrls = imageArray.map((img: any) => img.url);
        setBannerImages(imageUrls);
      } else {
        setBannerImages([]);
      }
    } else {
      setBannerImages([]);
    }
  }, [templateImages, template]);

  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section Nine Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={editData?.theme_2?.home?.section_9?.title}
                      onChange={handleChange}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">Paragraph</label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleChange({
                            target: {
                              name: 'paragraph',
                              value: content,
                            },
                          });
                        }}
                        contentType="mobile_app_description"
                        placeholder="Describe what you want in your paragraph. Example: 'Write about our mobile app features'"
                        context="This is for a mobile app section description"
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      name="paragraph"
                      value={editData?.theme_2?.home?.section_9?.paragraph}
                      onChange={handleChange}
                      maxLength={1200}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Android Link</label>
                    <input
                      type="text"
                      className="form-control"
                      name="android_link"
                      value={editData?.theme_2?.home?.section_9?.android_link}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">IOS Link</label>
                    <input
                      type="text"
                      className="form-control"
                      name="ios_link"
                      value={editData?.theme_2?.home?.section_9?.ios_link}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={editData?.theme_2?.home?.section_9?.h2color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_2?.home?.section_9?.h2color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={editData?.theme_2?.home?.section_9?.paracolor}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_2?.home?.section_9?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <AIImageGenerator
                generateAutoPrompt={generateAutoPrompt}
                onSave={handleAIImageSave}
                imageType="image"
                defaultWidth="1024"
                defaultHeight="1024"
                title="AI Image"
                autoGenerate={true}
                template={template}
              />

              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="img-bg active">
                          <img
                            src={editData?.theme_2?.home?.section_9?.banner}
                            alt="Card Icon"
                          />
                        </div>
                      </div>
                      <div className="img-options">
                        <div className="row">
                          <div className="col-md-12">
                            {bannerImages.length > 0 ? (
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 1,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                  },
                                }}
                                className="homejson-slider"
                              >
                                {bannerImages.map((images: string, index: any) => {
                                  return (
                                    <SwiperSlide key={index}>
                                      <div
                                        className="img-option"
                                        onClick={() =>
                                          handleImageChange(images)
                                        }
                                      >
                                        <img
                                          src={images}
                                          alt="Mobile App Image"
                                          className="img-fluid"
                                        />
                                      </div>
                                    </SwiperSlide>
                                  );
                                })}
                              </Swiper>
                            ) : (
                              <div className="empty-slider-state text-center py-4">
                                <div className="empty-state-content">
                                  <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                  <h6 className="text-muted mb-2">No Images Available</h6>
                                  <p className="text-muted small mb-3">
                                    Generate AI images or upload your own to see them here
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Upload Image</label>
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control"
                        name="image"
                        onChange={updateImageSectionOne}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </Draggable> */}
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default MobileAppEditModal;
